import React, {
    FC, useState, useRef, useEffect, RefObject,
} from 'react';
import { ISetCard } from './types';
import css from './BR1258sets5dishes.module.scss';

import ArrowIcon from './img/stubArrow.component.svg';

export const BR1258Sets5DishesCardStub: FC<ISetCard> = ({
    onClick = () => { },
    disabled = false,
}: ISetCard) => {
    const stubButtonRef: RefObject<HTMLDivElement> = useRef<HTMLDivElement>(null);
    return (
        <button
            className={`shadow-l ${css.linkCardNewUI}`}
            onClick={onClick}
            type="button"
            disabled={disabled}
        >

            <div
                className={`body-xs-medium ${css.linkTitleNewUI}`}
            >
                Ещё
                <br />
                больше блюд
                <br />
                в другие даты
            </div>
            <div
                ref={stubButtonRef}
                className={css.linkButtonNewUI}
            >
                <ArrowIcon />
            </div>
        </button>
    );
};
